import { useEffect } from "react";

const DatabaseFilterByBaseSearchResult = ({ view, model }) => {
  useEffect(() => {
    let baseFilter = { hepp: "hopp" };

    const [from, to, divider] = model.map[0];
    const updateSearch = ({ data }) => {
      const filter = {};
      filter[to] = (data || []).map((item) => item[from]).join(divider || "");
      baseFilter = filter;
    };
    view.baseView.on("search", -100, updateSearch);

    const onSearch = async (search) => {
      return { ...search, filter: baseFilter };
    };
    view.on("setSearch", 10, onSearch);
    view.baseView.event("setSearch").then(() => {
      setTimeout(() => view.event("setSearch"), 0);
    });

    return () => {
      view.off("setSearch", onSearch);
      view.baseView.off("search", updateSearch);
    };
  }, [view, model]);

  return null;
};

export default DatabaseFilterByBaseSearchResult;
